<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--클레임 처리상태-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001331') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--클레임 No.-->
							<th class="col-1">{{ getMessage_('QWCC001225') }}</th>
							<td class="col-1"><el-input v-model="clmNo" readOnly /></td>
							<!--처리단계-->
							<th class="col-1">{{ getMessage_('QWCC000963') }}</th>
							<td class="col-1">
								<el-input v-model="prcsStepClNm" readOnly />
							</td>
							<!--신청일-->
							<th class="col-1">{{ getMessage_('QWCC000979') }}</th>

							<td class="col-1">
								<el-input v-model="aplcDdCl" readOnly />
							</td>
							<!--확정일-->
							<th class="col-1">{{ getMessage_('QWCC000980') }}</th>
							<td class="col-1">
								<el-input v-model="dcsnDdCl" readOnly />
							</td>
							<!--변제대상-->
							<th class="col-1">{{ getMessage_('QWCC001332') }}</th>
							<td class="col-1">
								<el-radio
									v-model="radio"
									v-for="(item, index) in tgrpYnList"
									:key="index"
									:label="item.commCd"
									@change="changeTgRp"
									:disabled="clamMstPopUp.readOnlyAuth1"
									>{{ item.commCdName }}</el-radio
								>
							</td>
						</tr>

						<tr>
							<!-- 협력사-->
							<th class="col-1"> {{ getMessage_('QWCC001341') }}</th>
							<!-- <th class="col-1" v-if="clamMstPopUp.ctype !== 'W' && clamMstPopUp.ctype !=='S'">* {{ getMessage_('QWCC001341') }}</th>
							<th class="col-1" v-if="clamMstPopUp.ctype ==='W' || clamMstPopUp.ctype ==='S'">{{ getMessage_('QWCC001341') }}</th> -->
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="aplCpnyCd"
												class="inputWithIcon"
												@keyup.native.delete="onDelerInPutKeyDown()"
												:readonly="aplCpnyCdDisable"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onDelerPopup()"></i>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-2" colspan="2">
								<!--협력사명-->
								<el-input v-model="aplCpnyNm" :placeholder="getMessage_('QWCC001342')" readonly />
							</td>
							<!--실납품사-->
							<th class="col-1" v-if="clamMstPopUp.ctype !== 'W' && clamMstPopUp.ctype !=='S'">{{ getMessage_('QWCC001924') }}</th>
							<th class="col-1" v-if="clamMstPopUp.ctype ==='W' || clamMstPopUp.ctype ==='S'">* {{ getMessage_('QWCC001924') }}</th>
							<td class="col-1">
								<el-input v-model="dlvgNm" readonly />
							</td>

							<!--분담율/귀책율-->
							<!-- <th class="col-1">* {{ getMessage_('QWCC001980') }}</th> -->
							<th class="col-1" v-if="clamMstPopUp.ctype !== 'W' && clamMstPopUp.ctype !=='S'">{{ getMessage_('QWCC001980') }}</th>
							<th class="col-1" v-if="clamMstPopUp.ctype ==='W' || clamMstPopUp.ctype ==='S'">* {{ getMessage_('QWCC001980') }}</th>
							<td class="col-1">
								<el-input v-model="dvswRt" :readonly="isDisableConyCd" />
							</td>
							<!--적용 분담율/귀책율-->
							<th class="col-1">* {{ getMessage_('QWCC001981') }}</th>
							<td class="col-1">
								<!--	
								<el-input :value="aplDvswRt" @input="changeAplDvswRt"  :readonly="clamMstPopUp.readOnlyAuth" />
								-->

								<el-input :value="aplDvswRt" @input="val => changeAplDvswRt(val)" :readonly="clamMstPopUp.readOnlyAuth" />
							</td>
						</tr>

						<tr>
							<!--비고 -->
							<th class="col-1">{{ getMessage_('QWCC000906') }}</th>
							<td class="col-1" colspan="5">
								<el-input v-model="rmk" maxlength="300" :readonly="clamMstPopUp.readOnlyAuth" />
							</td>

							<!--변제금액 -->
							<!-- <th class="col-1">* {{ getMessage_('QWCC001295') }}</th> -->
							<th class="col-1" v-if="clamMstPopUp.ctype !== 'W' && clamMstPopUp.ctype !=='S'">{{ getMessage_('QWCC001295') }}</th>
							<th class="col-1" v-if="clamMstPopUp.ctype ==='W' || clamMstPopUp.ctype ==='S'">* {{ getMessage_('QWCC001295') }}</th>
							<td class="col-1">
								<el-input v-model="rpymAmt" :readonly="isDisableConyCd" />
							</td>
							<!--적용 변제금액 -->
							<th class="col-1">* {{ getMessage_('QWCC001306') }}</th>
							<td class="col-1">
								<el-input :value="aplRpymAmt" :readonly="clamMstPopUp.readOnlyAuth" @input="val => changeinput(val)" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam1: { type: Object }
	},
	components: {},
	data() {
		return {
			clmNo: '', //클래임번호
			tgrpYn: '', //변제대상
			aplCpnyCd: '', //납품업체
			aplCpnyNm: '', //납품업체명
			dvswRt: '', //분담율
			aplDvswRt: '', //적용분담율
			rpymAmt: '', //변제금액
			aplRpymAmt: '', //적용변제금액

			prcsStepClNm: '', //클레임 처리 코드명
			prcStepCl: '', //클레임 처리단계코드
			aplcDdCl: '', //클레임 신청일
			dcsnDdCl: '', //클레임 확정일
			radio: 'Y',
			rmk: '', //비고
			cpnyNm: '', //납품업체 팝업시 필요함,
			dlvgNm: '' //실납품사
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		},
		aplCpnyCdDisable() {
			if (this.clamMstPopUp.readOnlyAuth == true || this.clamMstPopUp.campaginGb == true) {
				// if (this.clamMstPopUp.aplCpnyCd != '' && this.clamMstPopUp.aplCpnyCd != null) {
				// 	return true;
				// } else {
				// 	return false;
				// }
				 return true;
			} else {
				if (this.clamMstPopUp.aplCpnyCd != '' && this.clamMstPopUp.aplCpnyCd != null) {
					return false;
				} else {
					return true;
				}
				// return false;
			}
		},
		isDisableConyCd() {
			if(this.clamMstPopUp.ctype !=='W' && this.clamMstPopUp.ctype !=='S'){
				return true;
			}else{
				if (this.clamMstPopUp.aplCpnyCd != '' && this.clamMstPopUp.aplCpnyCd != null) {
					return true;
				} else {
					return false;
				}
			}
			
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		changeinput(val) {
			this.aplRpymAmt = val;
			if (this.clamMstPopUp.aplCpnyCd != '' && this.clamMstPopUp.aplCpnyCd != null) {
				val = val.replace(/[^-\.0-9]/g, '');
				const arr = val.toString().split('.');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (val.length > 16) {
						val = val.slice(0, 16);
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 2) {
						arr[1] = arr[1].slice(0, 2);
					}
					if (arr[0].length > 16) {
						arr[0] = arr[0].slice(0, 16);
					}
					arr[1] = '.' + arr[1];
					val = arr.reduce((a, b) => a + b);
				}
				/*적용분담율 재계산한다.*/
				//적용변제금액 * 귀책율(분담율) / 변제금액
				const aplDvswRt = (this.aplRpymAmt * this.dvswRt) / this.rpymAmt;

				const result = Math.round((aplDvswRt + Number.EPSILON) * 100) / 100;

				this.aplDvswRt = isNaN(result) == true ? '0' : result;
			}
			
		},
		setAplRpymAmtInfo() {
			this.aplRpymAmt = this.clamMstPopUp.aplRpymAmt; //적용변제금액
		},
		setProcessInfo() {
			this.clmNo = this.clamMstPopUp.clmNo; //클레임번호
			this.tgrpYn = this.clamMstPopUp.tgrpYn; // 변제대상
			this.aplCpnyCd = this.clamMstPopUp.aplCpnyCd; //납품업체
			this.aplCpnyNm = this.clamMstPopUp.aplCpnyNm; //납품업체명
			this.dvswRt = this.clamMstPopUp.dvswRt; //분담율
			this.aplDvswRt = this.clamMstPopUp.aplDvswRt; //적용분담율
			this.rpymAmt = this.clamMstPopUp.rpymAmt; //변제금액
			this.aplRpymAmt = this.clamMstPopUp.aplRpymAmt; //적용변제금액

			this.prcStepCl = this.clamMstPopUp.prcStepCl; //처리단계코드
			this.prcsStepClNm = this.clamMstPopUp.prcsStepClNm; // 처리단계명
			this.aplcDdCl = this.clamMstPopUp.aplcDdCl; //신청일
			this.dcsnDdCl = this.clamMstPopUp.dcsnDdCl; //확정일
			this.rmk = this.clamMstPopUp.rmk; //비고
			this.dlvgNm = this.clamMstPopUp.dlvgNm; //실납품사.
		},
		changeTgRp(value) {
			this.tgrpYn = value;
		},
		onDelerInPutKeyDown() {
			if (this.clamMstPopUp.readOnlyAuth == false) {
				if (this.clamMstPopUp.campaginGb == true) {
					return false;
				}

				this.aplCpnyCd = '';
				this.aplCpnyNm = '';

				//분담율
				this.dvswRt = '';
				//적용 분담율
				this.aplDvswRt = '';

				//변제금액
				this.rpymAmt = '';
				//적용변제금액
				this.aplRpymAmt = '';
			}
		},
		onDelerPopup() {
			/*납품업체팝업*/
			//console.log('이거뭐지><<<<<<<', this.clamMstPopUp.campaginGb);

			if (this.clamMstPopUp.readOnlyAuth == false) {
				if (this.clamMstPopUp.campaginGb == true) {
					return false;
				}
				if(this.clamMstPopUp.aplCpnyCd == '' || this.clamMstPopUp.aplCpnyCd == null){
					return false;
				}

				this.cpnyNm = this.aplCpnyNm; //납품업체 팝업시 필요한 값
				let paramValue = {
					//행추가 이벤트시 필요한부분
					cpnyNm: this.aplCpnyNm, //협력사명
					roNo: this.clamMstPopUp.roNo, //ro번호
					causPartNo: this.clamMstPopUp.causPartNo, //원인부품번호
					calRpymAmtGb: true
				};

				this.$emit('OpenDelPopup', paramValue);
			}
		},
		async changeAplDvswRt(value) {
			value = value.replace(/[^\.0-9]/g, '');
			const arr = value.toString().split('.');
			if (arr.length > 2) {
				return;
			}
			if (arr.length == 1) {
				if (value.length > 16) {
					value = value.slice(0, 16);
				}
			}
			if (arr.length == 2) {
				if (arr[1].length > 2) {
					arr[1] = arr[1].slice(0, 2);
				}
				if (arr[0].length > 16) {
					arr[0] = arr[0].slice(0, 16);
				}
				arr[1] = '.' + arr[1];
				value = arr.reduce((a, b) => a + b);
			}

			this.aplDvswRt = value;

			try {
				if (value > 100) {
					//분담율 100이상 입력시 오류 메세지
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001776'), [this.getMessage_('QWCC001305')]));
					return false;
				} else {
					if (this.clamMstPopUp.aplCpnyCd != '' && this.clamMstPopUp.aplCpnyCd != null) {
						let tmpAplCpnyCd = convertNvl(this.aplCpnyCd, '');
						let inputValue = convertNvl(value, '');

						// if (tmpAplCpnyCd == '') {
						// 	throw new Error(this.getMessage_('QWCC001987')); // 협력사를 선택해주세요.
						// }

						//console.log('입력된분담율', value);

						if (inputValue == '') {
							//분담율이 없으면 분담금액을 공백으로 초기화 한다.
							this.aplRpymAmt = '';
							return false;
						} else if (inputValue == '.') {
							inputValue = 0.0;
							this.aplDvswRt = 0.0;
						}

						let paramValue = {
							cpnyCd: convertNvl(this.aplCpnyCd, ''), //협력사
							roNo: convertNvl(this.clamMstPopUp.roNo, ''), //ro번호
							causPartNo: convertNvl(this.clamMstPopUp.causPartNo, ''), //원인부품번호
							cmpnNo: convertNvl(this.clamMstPopUp.cmpnNo, ''), //캠페인번호
							rtsh: inputValue
						};

						//console.log('값은>>', paramValue);

						await this.getCalAplRpymAmt_(paramValue);
						this.setAplRpymAmtInfo();
					}
			   } 
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
				return false;
			}
		}
	},
	async created() {
		//스토어에서 값을 가져와서 셋팅한다.
		try {
			await this.getCommCodes_({ key: 'tgrpYnList', codeType: 'YN' });

			this.clmNo = this.clamMstPopUp.clmNo; //클레임번호
			this.tgrpYn = this.clamMstPopUp.tgrpYn || 'Y'; // 변제대상
			this.radio = this.clamMstPopUp.tgrpYn || 'Y'; // 변제대상 라디오 디스플레이
			this.aplCpnyCd = this.clamMstPopUp.aplCpnyCd; //납품업체
			this.aplCpnyNm = this.clamMstPopUp.aplCpnyNm; //납품업체명
			this.dvswRt = this.clamMstPopUp.dvswRt; //분담율
			this.aplDvswRt = this.clamMstPopUp.aplDvswRt; //적용분담율
			this.rpymAmt = this.clamMstPopUp.rpymAmt; //변제금액
			this.aplRpymAmt = this.clamMstPopUp.aplRpymAmt; //적용변제금액

			this.prcStepCl = this.clamMstPopUp.prcStepCl; //처리단계코드
			this.prcsStepClNm = this.clamMstPopUp.prcsStepClNm; // 처리단계명
			this.aplcDdCl = this.clamMstPopUp.aplcDdCl; //신청일
			this.dcsnDdCl = this.clamMstPopUp.dcsnDdCl; //확정일
			this.rmk = this.clamMstPopUp.rmk; //비고
			this.dlvgNm = this.clamMstPopUp.dlvgNm; //실납품사.
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	},
	watch: {
		sendParam1(newValue, oldValue) {
			//딜러점
			this.aplCpnyCd = this.sendParam1.cpnyCd;
			this.aplCpnyNm = this.sendParam1.cpnyNm;

			//console.log('최종값>>>', this.sendParam1);

			//분담율
			this.dvswRt = this.sendParam1.rtsh;
			//적용분담율
			this.aplDvswRt = this.sendParam1.aplDvswRt;

			this.rpymAmt = this.sendParam1.rpymAmt;

			this.aplRpymAmt = this.sendParam1.aplRpymAmt;

			//let tmpDvswRt = this.sendParam1.rtsh;
			//let tmpAplRpyAmt = convertNvl(tmpDvswRt, '') == '' ? '' : (Number.parseInt(tmpDvswRt) / 100) * Number.parseInt(this.rpymAmt);

			//적용변제금액  = (적용분담율 /100) * 변제금액  절삭해서 넣는다.소수점 없이.ㄹ
			//this.aplRpymAmt = Math.floor(tmpAplRpyAmt);
		},
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateClamSave_({ key: 'clmNo', value: convertNvl(this.clmNo, '') }); // 클레임번호
				this.setStateClamSave_({ key: 'tgrpYn', value: convertNvl(this.tgrpYn, '') }); // 변제대상
				this.setStateClamSave_({ key: 'aplCpnyCd', value: convertNvl(this.aplCpnyCd, '') }); // 납품업체
				this.setStateClamSave_({ key: 'aplCpnyNm', value: convertNvl(this.aplCpnyNm, '') }); // 납품업체명
				this.setStateClamSave_({ key: 'dvswRt', value: convertNvl(this.dvswRt, '') }); // 분담율
				this.setStateClamSave_({ key: 'aplDvswRt', value: convertNvl(this.aplDvswRt, '') }); // 적용분담율
				this.setStateClamSave_({ key: 'rpymAmt', value: convertNvl(this.rpymAmt, '') }); // 변제금액
				this.setStateClamSave_({ key: 'aplRpymAmt', value: convertNvl(this.aplRpymAmt, '') }); // 적용변제금액
				this.setStateClamSave_({ key: 'prcStep', value: convertNvl(this.prcStepCl, '') }); // 클레임 처리상태코드단계코드
				this.setStateClamSave_({ key: 'prcsStepNm', value: convertNvl(this.prcsStepClNm, '') }); // 클레임 처리단계명
				this.setStateClamSave_({ key: 'rmk', value: convertNvl(this.rmk, '') }); // 클레임 처리단계명
				this.setStateClamSave_({ key: 'dlvgNm', value: convertNvl(this.dlvgNm, '') });
				this.setStateClamSave_({ key: 'ctype', value: convertNvl(this.clamMstPopUp.ctype, '') });
			}
		}
	}
};
</script>
<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
